module.exports = (__parcel__import__("./" + "Doppio.ee8914df.js")).then(() => parcelRequire('jTOzh'));